import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '../../configurations/server-config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  getAccount(page = 0, size = 10): Observable<any> {
    return this.http.get(`${API_URL}/account?page=${page}&size=${size}`);
  }

  getRole(): Observable<any> {
    return this.http.get(`${API_URL}/rolelist`);
  }

  saveuser(value: any): any {
    return this.http.post(`${API_URL}/createuser`, value);
  }

  getuserinfo(id: any): Observable<any> {
    return this.http.get(`${API_URL}/getuserinfo/${id}`);
  }

  updateusersession(id: any, session: any, ids: any): Observable<any> {
    return this.http.post(`${API_URL}/updatesession`, {ids: id, sessionid: session, idsession: ids});
  }

  updateusersessionAmount(id: any, session: any, ids: any): Observable<any> {
    return this.http.post(`${API_URL}/updatesessionamount`, {sessionid: session, idsession: ids});
  }

  updateuser(value: any): any {
    return this.http.put(`${API_URL}/updateuser`, value);
  }

  disabledaccount(id: any, statu: any): any {
    return this.http.post(`${API_URL}/disable`, {accountid: id, status: statu});
  }

  checkloginname(name: any): any {
    return this.http.get(`${API_URL}/checkaccountexist/${name}`);
  }

  deleteaccount(id: any): any {
    return this.http.post(`${API_URL}/delete`, {accountid: id});
  }

  updatepassword(id: any, pass: any): any {
    return this.http.post(`${API_URL}/updatepassword`, {accountid: id, password: pass});
  }
  checkpassword(id: any, pass: any): any {
    return this.http.post(`${API_URL}/checkpassword`, {accountid: id, password: pass});
  }
}
